import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetFleetInspectionType } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupFleetInspectionType = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (FleetInspectionType?.length === 0) {
      dispatch(GetFleetInspectionType());
    }
  }, []);

  const { FleetInspectionType, loading, error } = useSelector(state => state.Lookup);

  const FleetInspectionTypeOptions = FleetInspectionType?.map((item, idx) =>
    item.list?.map(list => ({
      label: i18n.language === 'en' ? list.meaning : list.meaning2,
      value: list.lookupCode
    }))
  )[0];

  return { FleetInspectionType, FleetInspectionTypeOptions, loading, error };
};

export default useLookupFleetInspectionType;
